
if (!customElements.get("float-quickadd")) {
  class FloatQuickadd extends HTMLElement {
    // 代理源
    _refOrigin = {
      variant: null, // 产品变体
    };

    constructor() {
      super();
      // 选择器
      const selectors = {
        outElement: `#${this.getAttribute('data-out-element-id')}`,
        mediaSlide: '.swiper-slide',
        mediaItem: '.float-quickadd__media',
        form: '.float-quickadd__form-wrapper>form',
        variantSelect: '.float-quickadd__product__select',
        variantsJson: '.pr_variants_json',
        optionsJson: '.pr_options_json',
        productImage: '[data-quickadd-product-image]',
        priceWrapper: '.float-quickadd__product__price-review',
        nowPrice: '.float-quickadd__product__price',
        comparePrice: '.float-quickadd__product__compare_price',
        swatch: '.float-quickadd__swatch',
        swatchOption: '.float-quickadd__swatch .float-quickadd__swatch__option',
        swatchOptionLabel: '.float-quickadd__swatch__title .float-quickadd__swatch__current',
        swatchOptionItem: '.float-quickadd__swatch__list .float-quickadd__swatch__item',
        qtyInput: '.quantity-input',
        addToCartBtn: 'add-cart-button',
        select: '[data-quickadd-select]',
        selectLabel: '[data-quickadd-select-label]',
        optionsDetails: '[data-options-details]',
      };
      this.selectors = selectors;
      // 标记
      const marks = {
        selectedClass: 'is--selected',
        optionDisabledClass: 'is--disabled', // 选项禁止选择
        soldStatus: {
          // 产品可售状态
          available: 'available',
          soldOut: 'sold-out', // 售罄
        },
        activeClass: 'active',
      };
      this.marks = marks;
      // 元素
      const elements = {
        outElement: document.querySelector(selectors.outElement),
        mediaSlideList: this.querySelectorAll(selectors.mediaSlide),
        form: this.querySelectorAll(selectors.form),
        variantSelect: this.querySelector(selectors.variantSelect),
        variantsJson: this.querySelector(selectors.variantsJson),
        optionsJson: this.querySelector(selectors.optionsJson),
        productImage: this.querySelector(selectors.productImage),
        priceWrapper: this.querySelector(selectors.priceWrapper),
        nowPrice: this.querySelector(selectors.nowPrice),
        comparePrice: this.querySelector(selectors.comparePrice),
        swatch: this.querySelector(selectors.swatch),
        swatchOptionList: this.querySelectorAll(selectors.swatchOption),
        swatchOptionItemList: this.querySelectorAll(selectors.swatchOptionItem),
        qtyInput: this.querySelector(selectors.qtyInput),
        addToCartBtn: this.querySelector(selectors.addToCartBtn),
        select: this.querySelector(selectors.select),
        selectLabel: this.querySelector(selectors.selectLabel),
        optionsDetails: this.querySelector(selectors.optionsDetails),
      };
      this.elements = elements;
      this.variantsJson = JSON.parse(elements.variantsJson.innerHTML);
      this.optionsJson = JSON.parse(elements.optionsJson.innerHTML);

      this.product_featured_media = this.elements.productImage.src;
      this.productAvailable = this.getAttribute('data-product-available');

      // 代理，数据驱动型
      const proxyHander = {
        get(target, key) {
          return target[key];
        },
        set: (target, property, value) => {
          target[property] = value;
          this.handleRefChanged(this._refOrigin);
          return true;
        },
      };
      const ref = new Proxy(this._refOrigin, proxyHander);
      this.ref = ref;

      this.selectOptons = []; // 已选择的配置

      // 初始化已选择的配置
      for (let option of this.optionsJson) {
        this.selectOptons[option.position - 1] = option.values[0];
      }
      // 初始化代理
      // this.ref.variant = this.variantsJson[0];
      this.initEvent();
    }

    connectedCallback() { }

    get selectedOptionValues() {
      // select option[selected], 
      return Array.from(this.querySelectorAll('[data-swatch-item].is--selected')).map(
        ({ dataset }) => dataset.optionValueId
      );
    }

    /** 变更变体，供外部调用，变体/变体ID 两种可选 */
    changeVariant({ variant, variantId }) {
      console.log(variant, variantId)
      if (variant != undefined) {
        this.ref.variant = variant;
      } else if (variantId != undefined) {
        const selectedVariant = this.variantsJson.find((v) => v.id == variantId);
        if (selectedVariant) this.ref.variant = selectedVariant;
      }
    }

    /** 代理发生变化
     * @param {{variant}} refOrigin 
     */
    handleRefChanged(refOrigin) {
      // 更新变体选择器的值
      this.elements.variantSelect.value = refOrigin.variant.id;
      this.elements.addToCartBtn?.setAttribute('data-variant-id', refOrigin.variant.id);
      // 更新已选 Option 项存储数据
      this.selectOptons.length = 0;
      this.selectOptons.push(...refOrigin.variant.options);
      // 更新选 Option 标题视图
      for (let optionEl of this.elements.swatchOptionList) {
        const optionPosition = optionEl.getAttribute('data-option-position');
        const labelEl = optionEl.querySelector(this.selectors.swatchOptionLabel);
        // console.log(optionEl);
        labelEl.innerHTML = this.selectOptons[optionPosition - 1];
      }
      // 更新选 Option 项视图
      for (let optionItemEl of this.elements.swatchOptionItemList) {
        const optionPosition = optionItemEl.getAttribute('data-option-position');
        const value = optionItemEl.getAttribute('data-value');
        const nowIsActived = optionItemEl.classList.contains(this.marks.selectedClass);
        const needIsActived = value == this.selectOptons[optionPosition - 1];
        if (nowIsActived != needIsActived) {
          // 选择项与代理不相同时，才会更新视图
          if (nowIsActived) optionItemEl.classList.remove(this.marks.selectedClass);
          else optionItemEl.classList.add(this.marks.selectedClass);
        }
        // 有时，该选项不能与其他已选项搭配在一起，因为可能没有这样子的变体
        const tempOptions = [...this.selectOptons];
        tempOptions[optionPosition - 1] = value;
        const isExist = this.variantsJson.findIndex((v) => v.options.toString() == tempOptions.toString()) > -1;
        const isDisabled = optionItemEl.classList.contains(this.marks.optionDisabledClass);
        if (isExist == isDisabled) {
          isExist
            ? optionItemEl.classList.remove(this.marks.optionDisabledClass)
            : optionItemEl.classList.add(this.marks.optionDisabledClass);
        }
      }
      // 更新图片
      this.elements.productImage.src = this.ref.variant?.featured_image?.src ?? this.product_featured_media;
      // 更新价格
      const comparePrice = this.ref.variant.compare_at_price; // 可能为 null、0
      const price = this.ref.variant.price;
      this.elements.comparePrice.innerHTML = comparePrice && comparePrice > 0 ? `$${(comparePrice / 100).toFixed(2)}` : '';
      this.elements.nowPrice.innerHTML = `$${(price / 100).toFixed(2)}`;
      this.elements.priceWrapper.setAttribute('data-discounted', comparePrice > price);
      // 更新可售状态
      this.setAttribute(
        'data-sold-status',
        this.ref.variant.available ? this.marks.soldStatus.available : this.marks.soldStatus.soldOut
      );;
      // 更新选择器
      if (this.elements.selectLabel) {
        let selectLabelHTML = '';
        for (const option of refOrigin.variant.options) {
          selectLabelHTML += `<span>${option}</span>`;
        }
        this.elements.selectLabel.innerHTML = selectLabelHTML;
      }
    }

    open() {
      this.setAttribute('open', '');
    }

    close() {
      this.removeAttribute('open');
      this.setAttribute('closing', '');
      setTimeout(() => {
        this.removeAttribute('closing');
      }, 500);
    }
    showSmile() {
      let waiting_smile_launcher = setInterval(()=>{
        if(document.querySelector(".smile-launcher-frame-container")) {
          clearInterval(waiting_smile_launcher);
          document.querySelector(".smile-launcher-frame-container").classList.add("lifted");
          document.querySelector(".smile-launcher-frame-container").style.setProperty("--bottom",`${128 + 10}px`);
          // setTimeout(()=>{
          
          //   console.log("this.getBoundingClientRect().height",this.getBoundingClientRect().height);
            
          // },600)
        }else {
          console.log("waiting...");
        }
      },1000); 
       
    }
    hideSmile() {
       document.querySelector(".smile-launcher-frame-container").classList.remove("lifted");
    }
    show() {
      if (!this.hasAttribute('open')) {
        this.showSmile();
        this.setAttribute('open', '');
         // let waiting_smile_launcher = setInterval(()=>{
         //   if(document.querySelector(".smile-launcher-frame-container")) {
         //     document.querySelector(".smile-launcher-frame-container").classList.add("lifted");
         //     document.querySelector(".smile-launcher-frame-container").style.setProperty("--bottom",`${this.getBoundingClientRect().height}px`);
         //     clearInterval(waiting_smile_launcher);
         //   }
         // },50); 
        
        
      }
    }

    hide() {
      if (this.hasAttribute('open')) {
        this.hideSmile();
        this.removeAttribute('open');
        this.setAttribute('closing', '');
        setTimeout(() => {
          this.removeAttribute('closing');
        }, 500);
      }
    }

    updateQuantity(change) {
      let currentQty = parseInt(this.elements.qtyInput.value, 10);
      const maxQty = this.ref.variant.quantity_rule.max ?? Infinity;

      // 更新数量
      currentQty += change;
      if (currentQty < 1) currentQty = 1;
      if (currentQty > maxQty) currentQty = maxQty;

      this.elements.qtyInput.value = currentQty;
      this.elements.addToCartBtn?.setAttribute('data-quantity', currentQty);
    }

    initEvent() {
      window.addEventListener('scroll', () => {
        const bound = this.elements.outElement.getBoundingClientRect()
        const show = window.scrollY > (bound.top + bound.height + window.scrollY - window.innerHeight / 5);
        if (show && this.productAvailable) {
          this.show();
        } else {
          this.hide();
        }
      });
      this.elements.variantSelect.addEventListener('change', (e) => {
        const variantId = this.elements.variantSelect.value;
        const selectedVariant = this.variantsJson.find((v, i, obj) => v.id == variantId);
        this.ref.variant = selectedVariant;
      });
      this.elements.swatch.addEventListener('click', (e) => {
        // 判断点击的元素是否为span，如果是则查找其父元素
        const swatchItem = e.target.matches(this.selectors.swatchOptionItem)
          ? e.target
          : e.target.closest(this.selectors.swatchOptionItem);

        if (swatchItem) {
          // 点击了选择项
          const currentEl = swatchItem;
          const isActived = currentEl.classList.contains(this.marks.selectedClass);
          if (isActived) return;
          currentEl.classList.add(this.marks.selectedClass); // 将选中的元素添加 selectedClass
          const optionPosition = currentEl.getAttribute('data-option-position');
          const optionValue = currentEl.getAttribute('data-value');
          this.selectOptons[optionPosition - 1] = optionValue;
          // 根据所有已选项，找出对应的变体
          const find = this.variantsJson.find((v, i) => v.options.toString() === this.selectOptons.toString());
          if (find) this.ref.variant = find;
          // 通知外部改变变体选项
          const target = this;
          publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event: e,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        }
      });
      // 点击选择器展示或收缩选项列表
      this.elements.select?.addEventListener('click', () => {
        if (this.elements.optionsDetails.isOpened) {
          this.elements.select.classList.remove('active');
          this.elements.optionsDetails.closeDetails();
        } else {
          this.elements.select.classList.add('active');
          this.elements.optionsDetails.openDetails();
        }
          this.showSmile();
      });
      // 购物车更新回调
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (this.hasAttribute('open')) {
          this.close();
        }
      });
    }
  }

  customElements.define("float-quickadd", FloatQuickadd);
}
